import { Box, IconButton, Tooltip } from '@mui/material';
import React, { useState } from 'react';

import { CellRendererParams } from 'routes/BudgetModule/config/types';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteUserGroupModal from '../components/DeleteUserGroupModal';
import EditUserGroupModal from '../components/EditUserGroupModal';
import UpdateIcon from '@mui/icons-material/Edit';
import { UserGroupSummaryT } from 'business/definitions';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const StyIconsContainer = styled(Box, {
    name: 'StyIconsContainer',
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

const StyIconButton = styled(IconButton, {
    name: 'StyIconButton',
})(({ theme }) => ({
    color: theme.palette.primary.main,
}));

type ActionsCellRendererProps = CellRendererParams<
    UserGroupSummaryT | undefined
> & { existingGroupsNames: string[] };

const ActionsCellRenderer = ({
    value,
    existingGroupsNames,
}: ActionsCellRendererProps): JSX.Element => {
    const { t } = useTranslation();
    const [isDeleteUserGroupModalOpen, setIsDeleteUserGroupModalOpen] =
        useState(false);
    const [isEditUserGroupModalOpen, setIsEditUserGroupModalOpen] =
        useState(false);

    if (!value) return <></>;

    return (
        <>
            <StyIconsContainer>
                <Tooltip title={t('common.modify')}>
                    <StyIconButton
                        data-testid={`e2e-update-group-button-${value.id}`}
                        size="small"
                        onClick={() => setIsEditUserGroupModalOpen(true)}
                    >
                        <UpdateIcon />
                    </StyIconButton>
                </Tooltip>
                <Tooltip title={t('common.delete')}>
                    <StyIconButton
                        data-testid={`e2e-delete-group-button-${value.id}`}
                        size="small"
                        onClick={() => setIsDeleteUserGroupModalOpen(true)}
                    >
                        <DeleteIcon />
                    </StyIconButton>
                </Tooltip>
            </StyIconsContainer>
            {isDeleteUserGroupModalOpen && (
                <DeleteUserGroupModal
                    isOpen={isDeleteUserGroupModalOpen}
                    onClose={() => {
                        setIsDeleteUserGroupModalOpen(false);
                    }}
                    userGroupId={value.id}
                />
            )}
            {isEditUserGroupModalOpen && (
                <EditUserGroupModal
                    isOpen={isEditUserGroupModalOpen}
                    onClose={() => {
                        setIsEditUserGroupModalOpen(false);
                    }}
                    existingGroupsNames={existingGroupsNames}
                    userGroupId={value.id}
                />
            )}
        </>
    );
};

export default ActionsCellRenderer;
